module.exports = __webpack_public_path__ + "img/diningIcon.d7568ba9.svg";